export { ProductDetails } from './ProductDetails';
